<template>
    <b-modal
        v-model="modalVisible"
        size="lg"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <template v-slot:modal-title>
            <div class="pb-2">SUBIR PDF DE GUÍA - ORDEN #{{ orderId }}</div>
        </template>
        
        <!-- Información de la orden -->
        <b-row class="mb-3" v-if="orderData">
            <b-col cols="12">
                <div class="p-2 bg-light rounded">
                    <p class="mb-0"><strong>Orden:</strong> #{{ orderId }}</p>
                    <p class="mb-0" v-if="orderData.customer"><strong>Cliente:</strong> {{ orderData.customer }}</p>
                    <p class="mb-0" v-if="orderData.date"><strong>Fecha:</strong> {{ orderData.date }}</p>
                </div>
            </b-col>
        </b-row>
        
        <b-row>
            <b-col cols="12">
                <p class="font-weight-medium">Seleccione el archivo PDF de la guía:</p>
            </b-col>
            <b-col cols="12">
                <b-form-file
                    v-model="selectedFile"
                    placeholder="Seleccione o arrastre un archivo..."
                    drop-placeholder="Suelte el archivo aquí..."
                    accept="application/pdf"
                    :state="Boolean(selectedFile)"
                ></b-form-file>
                <div class="mt-2">
                    <small class="text-muted">El archivo debe ser un PDF y no exceder 1MB de tamaño.</small>
                    <div v-if="fileErrorMessage" class="text-danger mt-1">
                        <small>{{ fileErrorMessage }}</small>
                    </div>
                </div>
            </b-col>
        </b-row>

        <!-- Vista previa del PDF si existe -->
        <div v-if="selectedFile && isValidFile" class="mt-3">
            <h6>Vista previa del archivo:</h6>
            <div class="d-flex align-items-center">
                <b-icon icon="file-earmark-pdf" variant="danger" font-scale="2"></b-icon>
                <div class="ml-2">
                    <div>{{ selectedFile.name }}</div>
                    <small>{{ formatFileSize(selectedFile.size) }}</small>
                </div>
            </div>
        </div>
        
        <template v-slot:modal-footer>
            <b-button variant="secondary" @click.prevent="closeModal">
                Cancelar
            </b-button>
            <b-button 
                variant="primary" 
                @click.prevent="uploadPdf"
                :disabled="!isValidFile || isLoading"
            >
                <b-spinner small v-if="isLoading"></b-spinner>
                {{ isLoading ? 'Subiendo...' : 'Subir PDF' }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "GuidePdfUploadModal",
    props: {
        modalVisible: {
            type: Boolean,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        orderId: {
            type: [String, Number],
            required: true
        },
        orderData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedFile: null
        }
    },
    computed: {
        fileErrorMessage() {
            if (!this.selectedFile) return null;
            
            // Validar tipo de archivo
            if (this.selectedFile.type !== 'application/pdf') {
                return 'El archivo debe ser un PDF';
            }
            
            // Validar tamaño (1MB = 1048576 bytes)
            if (this.selectedFile.size > 1048576) {
                return 'El archivo no debe exceder 1MB';
            }
            
            return null;
        },
        isValidFile() {
            return this.selectedFile && !this.fileErrorMessage;
        }
    },
    methods: {
        uploadPdf() {
            if (!this.isValidFile) {
                this.$bvToast.toast(this.fileErrorMessage || 'Por favor seleccione un archivo PDF válido', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
                return;
            }
            
            // Crear FormData
            const formData = new FormData();
            formData.append('guide_pdf', this.selectedFile);
            formData.append('order_id', this.orderId);
            
            // Emitir evento para que el componente padre maneje la carga
            this.$emit('upload-pdf', formData);
        },
        closeModal() {
            // Reiniciar el estado al cerrar
            this.selectedFile = null;
            this.$emit('close-modal');
        },
        formatFileSize(bytes) {
            if (bytes < 1024) return bytes + ' bytes';
            else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
            else return (bytes / 1048576).toFixed(1) + ' MB';
        }
    },
    watch: {
        // Reiniciar cuando se abre el modal
        modalVisible(newVal) {
            if (newVal) {
                this.selectedFile = null;
            }
        }
    }
};
</script>